/* eslint-disable */
import axios from '@/services/axios'

export default {
    login(credentials) {
        return axios.post("/auth", credentials);
    },
    logout() {
        return axios.post("/logout");
    },
    me(token) {
        return axios.post("/users/me", token);
    },
    check(search) {
        return axios.post("/emailcheck", search)
    },
    repwd(search) {
        return axios.post("/users/repwd", search)
    }
};
